import templateStr from 'text!./templates/vehicle-damageable-part.html';

export default [function () {
    return {
        scope: {
            part: '@',
            group: '@',
            damagedPartCode: '=',
            damagedGroup: '=',
            partClick: '='

        },
        restrict: 'A',
        template: templateStr,

        link: function link(scope) {
            scope.hovered = false;

            function isSelected() {
                if (scope.damagedGroup && scope.damagedGroup.code !== scope.group) {
                    return false;
                } else if (scope.damagedGroup && scope.damagedGroup.code === scope.group) {
                    return true;
                }

                if (scope.damagedGroup && scope.damagedPartCode === scope.part) {
                    return true;
                }

                return !!(scope.damagedGroup && scope.damagedPartCode === null);
            }

            scope.getIcon = function () {
                if (isSelected()) {
                    return 'onhover/damage_' + scope.part + '_on';
                }

                if (scope.hovered) {
                    return 'onhover/damage_' + scope.part + '_hover';
                }
                return 'damage_' + scope.part + '_off';
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/directives/VehicleDamageablePart.js
// module id = 1590
// module chunks = 0